module.exports = __webpack_public_path__ + "static/assets/7c9434c4f1f44e3d198db3bc77305fff.svg";